const modalTrigger = document.querySelector<HTMLElement>('.utility-nav-menu__nav-link--depth-1');
if (modalTrigger) {
	modalTrigger.setAttribute('data-sites-modal-trigger', 'sites-modal');
	modalTrigger.addEventListener('click', (e) => {
		e.preventDefault();
	});
	window.MicroModal.init({
		awaitOpenAnimation: true,
		awaitCloseAnimation: true,
		openTrigger: 'data-sites-modal-trigger',
		disableScroll: true,
	});
}
